import { useI18n } from '@radical/locale'
import { LAYOUT } from '../basic'

const { t } = useI18n()

const transform: RouteRecordItem = {
  path: '/transform',
  name: 'Transform',
  component: LAYOUT,
  redirect: { name: 'TransformList' },
  meta: {
    orderNo: 10,
    icon: 'tabler:transform',
    title: t('routes.transform.转换流'),
    hideChildrenInMenu: true,
  },
  children: [
    {
      path: 'list',
      name: 'TransformList',
      component: () => import('@/pages/transform/index.vue'),
      meta: {
        title: t('routes.transform.转换流管理'),
        icon: 'carbon:transform-binary',
      },
    },
  ],
}

export default transform
